// components
import GridPageAbstract from '../../abstract/GridPageAbstract';

export default class CommissionTypesPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'publicCommissionTypes';
        this.Server =
            this.props.context.getState().server.publicCommissionTypes;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name', 'description'];

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'name',
                    label: 'name',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'description',
                    label: 'description',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'agentId',
                    label: 'agent',
                    alignRight: false,
                    cell: 'Select',
                    displayGrid: true,
                    from: 'publicAgents',
                    object: 'agent',
                    show: 'name'
                },
                {
                    id: 'modifiedReason',
                    label: 'modifiedReason',
                    alignRight: false,
                    cell: 'BigText',
                    displayGrid: true,
                    disableEditor: true,
                },
                {
                    id: 'modifiedBy',
                    label: 'modifiedBy',
                    alignRight: false,
                    cell: 'Select',
                    object: 'modifiedBy',
                    show: 'firstName+lastName',
                    displayGrid: true,
                    disableEditor: true,
                    customSort: 'modifiedBy.firstName',
                },
                {
                    id: 'dateCreatedModified',
                    elements: ['dateCreated', 'dateModified'],
                    label: 'dateCreatedModified',
                    alignRight: false,
                    cell: 'CreateModify',
                    disableEditor: true,
                    displayGrid: true,
                    customSort: 'dateCreated',
                }
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
